import { FireRiskEnum } from '../../../../@core/fire-risk-dashboard/domain/enum/FireRisk.enum'
import { FarmRiskChartDataFactory } from './FarmRiskChartData.factory'
import { FarmRiskChartPlotBandsFactory } from './FarmRiskChartPlotBands.factory'

export class FarmFireRiskChartOptionsFactory {
	static make(risk: FireRiskEnum) {
		return {
			chart: {
				type: 'gauge',
				plotBackgroundColor: '#fefefe',
				plotBackgroundImage: null,
				plotBorderWidth: 0,
				plotShadow: false,
				dataLabels: {
					enabled: false,
				},
				exporting: {
					enabled: false,
				},
				height: 221,
				width: 380,
				margin: [0, 0, 0, 0],
				spacing: [0, 0, 0, 0],
			},

			title: {
				text: '',
			},

			pane: {
				startAngle: -90,
				endAngle: 89.9,
				background: null,
				center: ['50%', '75%'],
				size: '140%',
			},
			yAxis: {
				min: 0,
				max: 100,
				tickPixelInterval: null,
				tickPosition: 'inside',
				tickColor: 'var(--highcharts-background-color, #FFFFFF)',
				tickLength: 0,
				tickWidth: 0,
				minorTickInterval: null,
				labels: {
					enabled: false,
				},
				lineWidth: 0,
				plotBands: FarmRiskChartPlotBandsFactory.make(risk),
			},

			series: [
				{
					name: 'Speed',
					dataLabels: {
						enabled: false,
					},
					data: [FarmRiskChartDataFactory.make(risk)],
					tooltip: {
						enabled: false,
					},
					enableMouseTracking: false,
					dial: {
						radius: '80%',
						backgroundColor: '#272728',
						baseWidth: 12,
						baseLength: '0%',
						rearLength: '0%',
					},
					pivot: {
						backgroundColor: '#272728',
						radius: 6,
					},
				},
			],
		}
	}
}
